import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { fail_retrieve_brands_list, loading_retrieve_brands_list, reset_retrieve_brands_list, success_retrieve_brands_list } from '../../reducers/auth_tenant/retrieve_brands_list_Slice';
import { RETRIEVE_BRANDS_ERROR_MSG, RETRIEVE_BRANDS_SUCCESS_MSG, RETRIEVE_SALES_REPRESENTATIVES_ERROR_MSG, RETRIEVE_SALES_REPRESENTATIVES_SUCCESS_MSG, TENANT_ADD_SALES_REPS_TO_AGENCY_ERROR_MSG, TENANT_ADD_SALES_REPS_TO_AGENCY_SUCCESS_MSG } from '../../utils/error_success_messages';
import * as app_consts from "../../utils/app_consts";
import { useSelector } from 'react-redux';
import { messageToast } from '../../utils/Utils';
import { fail_retrieve_tenant_sales_reps, loading_retrieve_tenant_sales_reps, reset_retrieve_tenant_sales_reps, success_retrieve_tenant_sales_reps } from '../../reducers/auth_tenant/retrieve_tenant_sales_reps_Slice';
import { RETRIEVE_BRANDS_LIST_API, RETRIEVE_TENANT_SALES_REP_BY_STATUS_API, TENANT_CREATE_AGENCY_SALES_REP_API } from '../../api/api_data';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { Button, Col, Icon, Row, RSelect } from '../Component';
import RadioInput from '../../pages/components/inputs/RadioInput';
import TextInput from '../../pages/components/inputs/TextInput';
import { fail_tenant_add_sales_rep_to_agency, loading_tenant_add_sales_rep_to_agency, reset_tenant_add_sales_rep_to_agency, success_tenant_add_sales_rep_to_agency } from '../../reducers/auth_tenant/tenant_add_sales_rep_to_agency_Slice';
import PhoneInput from 'react-phone-input-2';

const initialState = { name: "", mobile_number: "", email_address: "", type: "", tpin: "", allowed_products: [], creation_type: "", existing_id: "" };

const AddSalesRepToAgencyModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {

  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [formData, setFormData] = useState(initialState);
  const [retrieve_sales_rep_loading, setRetrieveSalesRepLoading] = useState([]);
  const [page_loading, setPageLoading] = useState(true);
  const [page_error, setPageError] = useState("");
  const [brands, setBrands] = useState([]);
  const [sales_rep_data, setSalesRepData] = useState([]);
  const { id } = useParams();
  const [all_sales_rep_data, setAllSalesRepData] = useState([]);

  useEffect(() => {
    setOpen(isOpen);
    setFormData(initialState);

    //
    if (isOpen)
    {
      dispatch(tenant_auth_actions_helper(loading_retrieve_brands_list, success_retrieve_brands_list, fail_retrieve_brands_list, RETRIEVE_BRANDS_ERROR_MSG, RETRIEVE_BRANDS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_BRANDS_LIST_API}`));
      dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_sales_reps, success_retrieve_tenant_sales_reps, fail_retrieve_tenant_sales_reps, RETRIEVE_SALES_REPRESENTATIVES_ERROR_MSG, RETRIEVE_SALES_REPRESENTATIVES_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_SALES_REP_BY_STATUS_API}/${app_consts.ACTIVE}`));
    }

  }, [isOpen]);
  // Listener
  const retrieve_categories_listener = useSelector((state) => state.retrieve_brands_list.retrieve_brands_list);

  useEffect(() => {
    if (retrieve_categories_listener.status !== app_consts.IDLE)
    {
      if (retrieve_categories_listener.status === app_consts.LOADING)
      {
        setRetrieveSalesRepLoading(true);
      } else
      {
        setRetrieveSalesRepLoading(false);
        if (retrieve_categories_listener.status === app_consts.FAIL)
        {
          messageToast(retrieve_categories_listener.message, app_consts.FAIL);
        } else if (retrieve_categories_listener.status === app_consts.SUCCESS)
        {
          // Set Brands
          const categories = retrieve_categories_listener.data?.map((cat) => { return { label: cat, value: cat }; });
          setBrands(categories);
        }
        dispatch(reset_retrieve_brands_list());
      }
    }
  }, [retrieve_categories_listener]);

  // Sales Reps
  const retrieve_tenant_sales_reps_listener = useSelector((state) => state.retrieve_tenant_sales_reps.retrieve_tenant_sales_reps);

  useEffect(() => {
    if (retrieve_tenant_sales_reps_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_sales_reps_listener.status === app_consts.LOADING)
      {
        setPageLoading(true);
        setPageError("");
      } else
      {
        setPageLoading(false);
        if (retrieve_tenant_sales_reps_listener.status === app_consts.FAIL)
        {
          setPageError(retrieve_tenant_sales_reps_listener.message);
          messageToast(retrieve_tenant_sales_reps_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_sales_reps_listener.status === app_consts.SUCCESS)
        {
          setAllSalesRepData(retrieve_tenant_sales_reps_listener.data);
          return_sales_reps(retrieve_tenant_sales_reps_listener.data);
        }
        dispatch(reset_retrieve_tenant_sales_reps());
      }
    }
  }, [retrieve_tenant_sales_reps_listener]);


  const return_sales_reps = (rep) => {
    const sales_reps = rep?.map((item) => {
      return { label: item?.name, value: item?.id };
    });
    setSalesRepData(sales_reps);
  };

  const handle_creation_selection = (typeSelection) => {
    setFormData({ ...formData, ["creation_type"]: typeSelection, name: "", mobile_number: "", email_address: "", type: "", tpin: "", allowed_products: "", mobile_number: "", existing_id: "" });
  };


  const getSelectedOption = (value, options) => {
    return options?.find(option => option.value === value) || null;
  };

  const handle_existing_id = (e) => {
    const found = all_sales_rep_data?.find((find_data) => { return e?.value === find_data?.id; });

    setFormData({ ...formData, name: found?.name, mobile_number: found?.mobile_number, email_address: found?.email_address, type: found?.type, tpin: found?.tpin, allowed_products: found?.allowed_products, existing_id: found?.id, existing_id: e.value });
  };


  // Handle Change Function
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  const handleSubmitAddSalesRep = () => {
    setError("");

    const sent_data = { ...formData, agency_id: id };
    dispatch(tenant_auth_actions_helper(loading_tenant_add_sales_rep_to_agency, success_tenant_add_sales_rep_to_agency, fail_tenant_add_sales_rep_to_agency, TENANT_ADD_SALES_REPS_TO_AGENCY_ERROR_MSG, TENANT_ADD_SALES_REPS_TO_AGENCY_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_CREATE_AGENCY_SALES_REP_API}`, sent_data));
  };
  // Sales Reps
  const tenant_add_sales_rep_to_agency_listener = useSelector((state) => state.tenant_add_sales_rep_to_agency.tenant_add_sales_rep_to_agency);

  useEffect(() => {
    if (tenant_add_sales_rep_to_agency_listener.status !== app_consts.IDLE)
    {
      if (tenant_add_sales_rep_to_agency_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoading(false);
        if (tenant_add_sales_rep_to_agency_listener.status === app_consts.FAIL)
        {
          setError(tenant_add_sales_rep_to_agency_listener.message);
          messageToast(tenant_add_sales_rep_to_agency_listener.message, app_consts.FAIL);
        } else if (tenant_add_sales_rep_to_agency_listener.status === app_consts.SUCCESS)
        {
          closeModal();
          successFunction();
        }
        dispatch(reset_tenant_add_sales_rep_to_agency());
      }
    }
  }, [tenant_add_sales_rep_to_agency_listener]);


  return (
    <>
      <Modal isOpen={open} toggle={page_loading || loading ? "" : closeModal} className="modal-dialog-centered" size={"md "}>
        <ModalHeader toggle={page_loading || loading ? "" : closeModal}>Add Sales Rep to Agency</ModalHeader>
        <ModalBody>
          {
            page_loading ?
              <>
                <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>Retrieveing Sales Rep Data...</div>
                  <div className="nk-loader mt-2  w-70 m-auto "></div>
                </div>
              </>
              :
              <>
                {
                  page_error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 16, marginTop: "90px" }}>{page_error}</div>
                      </div>
                    </>
                    :
                    <>
                      <Row className="g-4">
                        <Col size={12}>
                          <div className="form-group">
                            <label className="form-label" htmlFor="">
                              Creation Type<span className='text-danger pr-2'>{` *`}</span>
                            </label>
                            <div className="w-100 form-control-wrap d-flex flex-row">
                              <RadioInput
                                id={app_consts.EXISTING}
                                label="Existing"
                                className="custom-control custom-control-md custom-radio w-50"
                                handleChange={(e) => handle_creation_selection(e)}
                                name={"creation_type"}
                              />
                              <RadioInput
                                id={app_consts.NEW}
                                label="New"
                                className="custom-control custom-control-md custom-radio w-50"
                                handleChange={(e) => handle_creation_selection(e)}
                                name={"creation_type"}
                              />
                            </div>
                          </div>
                        </Col>
                        {
                          formData?.creation_type === app_consts.EXISTING && (
                            <>
                              <Col lg={12}>
                                <div className="form-group">
                                  <div className="form-label-group">
                                    <label className="form-label">
                                      <label className="form-label mb text-md" htmlFor="retrunable">
                                        Select Sales Rep<span className='text-danger pr-2'>{` *`}</span>
                                      </label>
                                    </label>
                                  </div>
                                  <div className="w-100">
                                    <RSelect
                                      options={sales_rep_data}
                                      className="w-100"
                                      placeholder="Search"
                                      value={getSelectedOption(formData?.existing_id, sales_rep_data)}
                                      onChange={(e) => handle_existing_id(e)}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </>
                          )
                        }
                        <hr />
                        {
                          (formData?.creation_type && (formData?.creation_type === app_consts.EXISTING && formData?.existing_id) || (formData?.creation_type === app_consts.NEW)) && (
                            <>
                              <TextInput
                                label="Name"
                                type="name"
                                id_val="name"
                                value={formData?.name}
                                colSize="6"
                                required
                                name="name"
                                handleChange={handleChange}
                                disabled={formData?.creation_type === app_consts.EXISTING}
                              />
                              {
                                formData?.creation_type === app_consts.EXISTING ?
                                  <>
                                    <TextInput
                                      label="Mobile Number"
                                      type="mobile_number"
                                      id_val="mobile_number"
                                      value={formData?.mobile_number}
                                      colSize="6"
                                      required
                                      name="mobile_number"
                                      handleChange={handleChange}
                                      disabled={formData?.creation_type === app_consts.EXISTING}
                                    />
                                  </>
                                  :
                                  <>
                                    <Col lg="6">
                                      <div className="form-group">
                                        <div className="form-label-group">
                                          <label className="form-label" htmlFor="mobile_number">
                                            Mobile Number<span className='text-danger pr-2'>{`* `}</span>
                                          </label>
                                        </div>
                                        <div className="form-control-wrap">
                                          <PhoneInput
                                            country={"zm"}
                                            value={formData?.mobile_number}
                                            onChange={(phone) => setFormData({ ...formData, mobile_number: phone })}
                                            copyNumbersOnly={false}
                                            inputStyle={{ width: '100%' }}
                                          />
                                        </div>
                                      </div>
                                    </Col>
                                  </>


                              }
                              <TextInput
                                label="Email Address"
                                type="email_address"
                                id_val="email_address"
                                value={formData?.email_address}
                                colSize="6"
                                required
                                name="email_address"
                                handleChange={handleChange}
                                disabled={formData?.creation_type === app_consts.EXISTING}
                              />
                              <TextInput
                                label="Type"
                                type="type"
                                id_val="type"
                                value={formData?.type}
                                colSize="6"
                                required
                                name="type"
                                handleChange={handleChange}
                                disabled={formData?.creation_type === app_consts.EXISTING}
                              />
                              <TextInput
                                label="TPIN (Optional)"
                                type="tpin"
                                id_val="tpin"
                                value={formData?.tpin}
                                colSize="6"
                                name="tpin"
                                handleChange={handleChange}
                                disabled={formData?.creation_type === app_consts.EXISTING}
                              />

                              {/* allowed_products */}
                              {
                                formData?.creation_type === app_consts.EXISTING ?
                                  <>
                                    <Col size={6}>
                                      <div className="form-group">
                                        <label className="form-label mb-1 text-md" htmlFor="retrunable">
                                          Allowed Products<span className='text-danger pr-2'>{` *`}</span>
                                        </label>
                                        <div style={styles.bubbleContainer} className='mt-2'>
                                          {formData?.allowed_products.map((text, index) => (
                                            <div key={index} className='bg-gray' style={styles.bubble}>
                                              {text}
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </Col>
                                  </>
                                  :
                                  <>
                                    <Col size={6}>
                                      <div className="form-group">
                                        {/* Label row with inline checkbox */}
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                          <label className="form-label text-md mb-0" htmlFor="packet_size">
                                            Allowed Products
                                            <span className="text-danger ml-1">*</span>
                                          </label>

                                          <label className="mb-0 d-flex align-items-center" style={{ fontSize: "0.9rem", cursor: "pointer" }}>
                                            <input
                                              type="checkbox"
                                              style={{ marginRight: 4 }}
                                              checked={formData?.allowed_products?.length === brands.length}
                                              onChange={(e) => {
                                                const allValues = e.target.checked ? brands.map((b) => b.value) : [];
                                                setFormData({
                                                  ...formData,
                                                  allowed_products: allValues,
                                                });
                                              }}
                                              className="mr-1"
                                            />
                                            <span className='ml-2'>Select All </span>

                                          </label>
                                        </div>

                                        {/* Multi-select */}
                                        <div className="w-100">
                                          <RSelect
                                            options={brands}
                                            isMulti
                                            id="packet_size"
                                            placeholder="Search"
                                            className="w-100"
                                            value={brands.filter((b) =>
                                              formData.allowed_products?.includes(b.value)
                                            )}
                                            onChange={(selected) => {
                                              const values = selected?.map((val) => val.value) || [];
                                              setFormData({
                                                ...formData,
                                                allowed_products: values,
                                              });
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </Col>
                                  </>
                              }
                            </>
                          )
                        }

                        {error && (
                          <div className="mb-3 w-100">
                            <Alert color="danger" className="alert-icon">
                              <Icon name="alert-circle" /> {error}{" "}
                            </Alert>
                          </div>
                        )}
                        <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                          <Button onClick={handleSubmitAddSalesRep} disabled={loading || !(formData?.name && formData?.allowed_products?.length > 0 && formData?.email_address && formData?.mobile_number && formData?.type && (formData?.creation_type === app_consts.EXISTING ? formData?.existing_id : true))} color="primary">
                            {loading ? <Spinner size="sm" color="light" /> : "Add Sales Rep"}
                          </Button>
                        </Col>
                      </Row>
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal >
    </>
  );
};


const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    width: "300px",
    gap: "8px",
    border: "1px solid #ccc",
    padding: "10px",
    borderRadius: "8px",
  },
  bubbleContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "5px",
  },
  bubble: {
    display: "flex",
    alignItems: "center",
    color: "white",
    padding: "5px 10px",
    borderRadius: "15px",
    fontSize: "14px",
  },
  close: {
    marginLeft: "8px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  input: {
    width: "100%",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
};

export default AddSalesRepToAgencyModal;